<template>
  <div>
    <transition-group name="fade">
      <div :class="modalClass" tabindex="-1" key="modal" v-if="open">
        <div :class="['modal-dialog','modal-'+size]">
          <div class="modal-content">

            <div class="modal-header" v-if="slotExists('header')">
              <slot name="header"></slot>
            </div>

            <div class="modal-body">
              <slot></slot>
            </div>

            <div class="modal-footer" v-if="slotExists('footer')">
              <slot name="footer"></slot>
            </div>

          </div>
        </div>
      </div>
      <div :class="modalBackdropClass" key="modal-backdrop" v-if="open"></div>
    </transition-group>
  </div>
</template>

<script>
  export default {
    name: 'base-modal',
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
    },
    computed: {
      body() {
        return document.querySelector('body');
      },
      modalClass() {
        return {
          modal: true,
          fade: true,
          in: this.open,
        };
      },
      modalBackdropClass() {
        return {
          'modal-backdrop': true,
          show: true,
          in: this.open,
        };
      },
    },
    methods: {
      slotExists(slotName) {
        return this.$slots[slotName];
      },
    },
    beforeUpdate() {
      if (this.open) {
        this.body.classList.add('modal-open');
      } else {
        this.body.classList.remove('modal-open');
      }
    },
  };

</script>

<style scoped>
  .modal {
    display:block;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all 0.5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// BaseModal.vue?27f94274